module.exports = __webpack_public_path__ + "img/wind.8bc9bf23.png";